import React, { useState } from "react";
import { BARS } from "./helpers";

/**
 * BarSelect — visual 6-bar signal selector.
 * Props: value (1-6 or null), onChange(n)
 */
export default function BarSelect({ value, onChange }) {
  const [hov, setHov] = useState(null);
  const show = hov ?? value;

  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(6,1fr)", gap: 3 }}>
        {BARS.map(b => (
          <button
            key={b.n}
            type="button"
            onClick={() => onChange(b.n)}
            onMouseEnter={() => setHov(b.n)}
            onMouseLeave={() => setHov(null)}
            onTouchStart={() => setHov(b.n)}
            onTouchEnd={() => setHov(null)}
            style={{
              padding: "8px 2px",
              border: `2px solid ${value === b.n ? b.c : "var(--border)"}`,
              borderRadius: 6,
              background: value === b.n ? `${b.c}18` : "var(--bg)",
              cursor: "pointer",
              textAlign: "center",
            }}
          >
            {/* Mini bar-chart */}
            <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end", gap: 1.5, height: 20, marginBottom: 2 }}>
              {[1, 2, 3, 4, 5, 6].map(i => (
                <div
                  key={i}
                  style={{
                    width: 3.5,
                    height: 2 + i * 2.8,
                    borderRadius: 1,
                    background: i <= b.n ? b.c : "var(--border)",
                  }}
                />
              ))}
            </div>
            <div style={{ fontSize: 9, fontWeight: 700, color: value === b.n ? b.c : "var(--muted)" }}>
              {b.n}
            </div>
          </button>
        ))}
      </div>

      {/* Distance label below */}
      {show && (() => {
        const b = BARS.find(x => x.n === show);
        return b ? (
          <div style={{
            marginTop: 4, padding: "5px 8px", background: "var(--surface)",
            borderRadius: 5, fontSize: 10, color: "var(--subtle)",
            display: "flex", gap: 10, justifyContent: "center",
          }}>
            <span>Abierto: <b style={{ color: b.c }}>{b.open}</b></span>
            <span>Techado: <b style={{ color: b.c }}>{b.closed}</b></span>
            <span style={{ color: "var(--muted)" }}>({b.tag})</span>
          </div>
        ) : null;
      })()}
    </div>
  );
}
